import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";

const QuestionPage = () => {
  const navigate = useNavigate();
  const [question, setQuestion] = useState("");
  const [studentId, setStudentId] = useState("");
  const [studentName, setStudentName] = useState("Beloved");

  useEffect(() => {
    const id = localStorage.getItem("student_id");
    const name = localStorage.getItem("student_name");

    if (!id) {
      alert("⚠️ Student ID missing. Please scan the QR again.");
      navigate("/StudentPage");
      return;
    }

    setStudentId(id);

    if (name && name.trim()) {
      const firstName = name.trim().split(" ")[0];
      setStudentName(firstName || "Beloved");
    }
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!question.trim()) {
      alert("❌ Question cannot be empty.");
      return;
    }

    try {
      const response = await fetch(
        `${process.env.REACT_APP_BACKEND_URL}/api/questions/ask`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ student_id: studentId, question }),
        }
      );

      const data = await response.json();

      if (response.ok) {
        console.log("✅ Question submitted:", data);
        navigate("/SubmissionPage");
      } else {
        alert("❌ Submission failed: " + (data.error || "Unknown error"));
      }
    } catch (err) {
      console.error("❌ Network error submitting question:", err);
      alert("Network error occurred. Please try again.");
    }
  };

  return (
    <>
      <header className="hide_for_confirmation_page">
        <div className="homebanner">
          <img src="homebanner.png" alt="HomePage Banner" />
        </div>
        <div className="homelogo">
          <img src="church_logo_no_bg.png" alt="Church Logo" />
        </div>
        <div className="cross_icon">
          <img src="cross_icon.png" alt="Cross Icon" />
        </div>
      </header>
      <header className="hide_for_media_query">
        <div className="media_query_banner media_query_banner1 ">
          <img src="banner_md.png" alt="Media Query Banner" />
          <img
            src="church_logo_no_bg.png"
            alt="Church Avatar No BG"
            className="media_query_logo media_query_logo1"
          />
        </div>
        <div className="cross_icon">
          <img src="cross_icon.png" alt="Church Cross Icon" />
        </div>
      </header>
      <footer>
        <div className="question">
          <div className="question_main">
            <div className="form_head question_form_head">
              <p className="form_head_p">
                Dear <b>{studentName},</b>
              </p>
              <p className="form_head_p">
                Please, enter your Question or Remark
              </p>
            </div>
            <div className="form_body">
              <form onSubmit={handleSubmit}>
                <div className="form_body1 question_form_body">
                  <textarea
                    cols="10"
                    rows="10"
                    value={question}
                    onChange={(e) => setQuestion(e.target.value)}
                    placeholder="Type your question here..."
                    required
                  ></textarea>
                </div>
                <button className="question_login_btn">SUBMIT</button>
              </form>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default QuestionPage;
